import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaTrash } from "react-icons/fa";
import api from '../../api/manage_database/LocationReq';
import SelectLocation from '../../components/SelectLocation';
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';


const LocationDelete = () => {

    const [Locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');

    const [locationData, setLocationData] = useState();
    
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setLocations(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchLocations();
    }, []);

    const handleDelete = () => {
        const fetchRecord = async () => {
            try {
                const response = await api.get(`record/${selectedLocation}`, {withCredentials: true});
                if (response.data.success) {
                    setLocationData(response.data.payload[0]);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        }
        fetchRecord();
    }

    useEffect(() => {
        const deleteRecord = async () => {
            try {
                const response = await api.delete(`record/${selectedLocation}`, {withCredentials: true});
                if (response.data.success) {
                    toast.success(`${response.data.message}`);
                    navigate(
                        `../record/${selectedLocation}`,
                        {
                            state: {
                                deleteRecordMessage: 'Deleted record from database!',
                                anotherTypeOfPage: true,
                                data: locationData
                            }
                        }
                    )
                } else {
                    toast.error('Something go wrong! Maybe check internet connection');
                }
            } catch (err) {
                console.log(err.response);
            }
        }

        if (locationData) {
            deleteRecord();
        }
    }, [locationData]);

    return (
        <div className='location-delete-container'>
            <h2 className='location-delete-title'>Location</h2>
            <div className='location-delete-card'>
                <div className='location-delete-label-select-wrapper'>
                    <label
                        htmlFor='location-select'
                        className='bold-label'
                    >
                        Location:
                    </label>
                    <SelectLocation
                        Locations={Locations}
                        selectedLocation={selectedLocation}
                        setSelectedLocation={setSelectedLocation}
                    />
                </div>
                <button className='location-delete-button' onClick={handleDelete}>Delete &nbsp; <FaTrash /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default LocationDelete;